<div class="alert alert-error">
    <p id="bss_fehlerText_txt">
        „Ihre Bezügestellennummer ist in den Stammdaten falsch hinterlegt. Daher ist keine Auskunft möglich. Bitte
        wenden Sie sich an Ihre Ansprechpartner(in) in der Familienkasse.“
    </p>
</div>
